function getAdminMenu(currentUser?) {
  if (!currentUser?.isAdmin) {
    return undefined;
  }
  return {
    title: 'Admin',
    submenu: [
      {
        title: 'Feedback',
        url: '/admin/feedback',
      },

      {
        title: 'Users',
        url: '/admin/users?page=1'
      },
      {
        title: 'Sheets',
        url: '/admin/sheets?page=1'
      },
      {
        title: 'Signups',
        url: '/admin/signups?page=1'
      },
      {
        title: 'Contact',
        url: '/admin/contact'
      }
    ]
  };
}

function getUserMenu(currentUser?) {
  if (!currentUser) {
    return undefined;
  }
  const isHost = currentUser?.participations?.some(p => p.isHost);
  return {
    title: currentUser?.displayName,
    submenu: [
      {
        title: 'My Account',
        url: '/account'
      },
      {
        title: 'My Orders',
        url: '/store/orders',
      },
      {
        title: 'My Invitations',
        url: '/invitations'
      },
      isHost && {
        title: 'My Hosting Shifts',
        url: '/store/hosting'
      },
      {
        title: 'Logout',
        url: '/logout'
      },
    ].filter(Boolean)
  };
}

function getLoggedOutMenuItems(currentUser?) {
  return currentUser ? [] :
    [
      {
        title: 'Pricing',
        url: '/home/pricing'
      },
      {
        title: 'Log In',
        url: '/login'
      },
      {
        title: 'Sign Up',
        url: '/sign_up'
      },
    ];
}

function getBaseMenuItems(currentUser) {
  const managedStores = currentUser?.participations
    ?.filter(p => p.isManager)
    .map(p => p.store) || [];

  const storeMenu = managedStores.length === 0
    ? {
        title: 'My Store',
        url: '/store',
      }
    : {
        title: 'Stores',
        submenu: [
          {
            title: 'My Store',
            url: '/store',
          },
          ...managedStores.map(store => ({
            title: store.name,
            url: `/store/managed/${store.token}`
          }))
        ]
      };

  return [
    {
      title: 'Create A Sheet',
      url: '/swiz/new',
    },
    {
      title: 'My Sheets',
      url: '/sheets',
    },
    ...[storeMenu]
  ];
}

export default function getMenuItems(currentUser?) {
  return [
    ...getBaseMenuItems(currentUser),
    ...getLoggedOutMenuItems(currentUser),
    getAdminMenu(currentUser),
    getUserMenu(currentUser)
  ].filter(Boolean);
}
